<template>
  <section>
    <social-header v-if="currentEnv" title="我的订单"></social-header>
    <!--头部-->
    <!--我的订单-->
    <div class="order-nav-wrap" :class="!currentEnv ? 'top0' : ''">
      <!-- 订单筛选栏 -->
      <ul v-show="!isShowSearchFilter" class="order-nav">
        <div class="left">
          <li class="nav-item time" @click="showFilter('time')" :class="{ active: isShowTimeFilter }">
            <span v-show="selectTimeData.length == 0">下单时间</span>
            <div class="select-time" v-show="selectTimeData.length != 0">
              <p class="fontColor">{{ selectTimeData[0] }}</p>
              <p class="fontColor">{{ selectTimeData[1] }}</p>
            </div>

            <img v-show="!isShowTimeFilter" src="./img/下箭头黑色.png" alt="" />
            <img v-show="isShowTimeFilter" src="./img/上箭头蓝色.png" alt="" />
          </li>
          <li class="nav-item state" @click="showFilter('state')" :class="{ active: isShowStateFilter }">
            <span v-show="selectNodeData.length == 0">更多筛选</span>
            <div v-show="selectNodeData.length != 0">
              <span class="fontColor" v-if="selectNodeData.length == 1">{{
                selectNodeData[0].value
              }}</span>
              <span class="fontColor" v-if="selectNodeData.length > 1">已选{{ selectNodeData.length }}个条件</span>
            </div>
            <img v-show="!isShowStateFilter" src="./img/下箭头黑色.png" alt="" />
            <img v-show="isShowStateFilter" src="./img/上箭头蓝色.png" alt="" />
          </li>
        </div>

        <li class="search right" @click="showFilter('search')" :class="{ active: isShowSearchFilter }">
          <i class="iconfont icon-sousuo"></i>
          <span>查找</span>
        </li>
      </ul>
      <!-- 下单时间筛选项 -->
      <div class="order-nav-list" v-show="isShowTimeFilter">
        <p @click="selectTime2SearchOrder(item.key)" v-for="item in OrderTime_ENUM" :key="item.key"
          :class="{ selectActive: item.key == selectTimeItem }">
          {{ item.value
          }}<i v-show="item.key == selectTimeItem" class="iconfont icon-select"></i>
        </p>
      </div>
      <!-- 订单状态筛选项 -->
      <div class="orderstate" v-show="isShowStateFilter">
        <div class="ordernav-state" v-for="item in OrderState_ENUM" :key="item.key">
          <div v-if="item.value" class="left">
            {{ item.value }}
          </div>
          <div class="right">
            <div class="orderState-wrap" :class="{ multimode: item.key == '1' }">
              <span @click="selectOrderNode(item2)" :class="{
                active: item2.selected,
                default: item2.key == '',
                none: item2.value == '',
              }" v-for="(item2, index) in item.child1" :key="index">{{ item2.value }}</span>
            </div>
            <div class="orderState-wrap">
              <span @click="selectOrderNode(item3)" :class="{ active: item3.selected }"
                v-for="(item3, index) in item.child2" :key="index">{{ item3.value }}</span>
            </div>
          </div>
        </div>
        <!-- 数据类型筛选项 -->
        <div class="ordernav-state" v-for="item in dataType" :key="item.key">
          <div v-if="item.value" class="left">
            {{ item.value }}
          </div>
          <div class="right">
            <div class="orderState-wrap" :class="{ multimode: item.key == '1' }">
              <span @click="selectDataType(item2)" :class="{
                active: item2.selected,
                default: item2.key == '',
                none: item2.value == '',
              }" v-for="(item2, index) in item.child1" :key="index">{{ item2.value }}</span>
            </div>
          </div>
        </div>
        <!-- 业务类型筛选项 -->
        <div class="ordernav-state" v-for="item in businessType" :key="item.key">
          <div v-if="item.value" class="left">
            {{ item.value }}
          </div>
          <div class="right">
            <div class="orderState-wrap" :class="{ multimode: item.key == '1' }">
              <span @click="selectBusinessType(item2)" :class="{
                active: item2.selected,
                default: item2.key == '',
                none: item2.value == '',
              }" v-for="(item2, index) in item.child1" :key="index">{{ item2.value }}</span>
            </div>
          </div>
        </div>
        <!-- 订单类型筛选项 -->
        <div class="ordernav-state" v-for="item in OrderType_ENUM" :key="item.key">
          <div v-if="item.value" class="left">
            {{ item.value }}
          </div>
          <div class="right">
            <div class="orderState-wrap" :class="{ multimode: item.key == '1' }">
              <span @click="selectOrderType(item2)" :class="{
                active: item2.selected,
                default: item2.key == '',
                none: item2.value == '',
              }" v-for="(item2, index) in item.child1" :key="index">{{ item2.value }}</span>
            </div>
          </div>
        </div>
        <div class="bottom-btn">
          <span @click="editOrderState('clear')" class="left">清空</span><span @click="editOrderState('confim')"
            class="right">确定</span>
        </div>
      </div>
      <!-- 搜索 -->
      <div class="search" v-show="isShowSearchFilter || isShowSearchCancel">
        <van-search v-model="searchOrderVal" show-action ref="search" placeholder="请输入查找订单号或手机号">
          <template #action>
            <div class="search-cancel" v-show="isShowSearchCancel" @click.self="reset">
              取消
            </div>
            <div class="search-confirm" v-show="!isShowSearchCancel" @keyup.enter="onSearch" @click.self="onSearch">
              搜索
            </div>
          </template></van-search>
      </div>
    </div>
    <van-calendar v-model="isShowSelectTime" type="range" ref="calendar" color="#1989fa" @confirm="confirmTime"
      @open="openCalendar" allow-same-day :min-date="minDate" :max-date="maxDate" confirm-text="完成"
      confirm-disabled-text="请选择截止时间" />
    <van-pull-refresh v-model="isPullRefresh" @refresh="onRefresh">
      <div class="orderList" v-show="orders.length > 0">
        <div class="orderItem" v-for="(item, index) in orders" v-bind:key="index">
          <div class="orderTitle">
            <div class="left">
              <span class="green" v-if="item.appId == '1501' || item.appId == '1801'">买车</span>
              <span class="orange" v-else-if="item.appId == '1001'">卖车</span>
              <span class="blue" v-else-if="item.appId == '1804'">内容</span>
              <span class="green" v-else>活动</span>
            </div>
            <div class="middle">
              {{ item.dataType == 1 ? "线索编号：" : "订单编号："
              }}{{ item.businessLineOrderId }}
            </div>
            <div class="right" @click="copy(item.businessLineOrderId)">
              <img src="./img/复制.png" alt="" />
            </div>
            <div class="view" v-if="item.dataType" @click="viewRelationOrder(item)">
              <span style="color: #3164f2" v-show="item.dataType == 1 && item.realtionId">查看首触订单</span><span
                style="color: #3164f2" v-show="item.dataType == 2 && item.clueId">查看关联线索</span>
            </div>
          </div>
          <div class="orderContent">
            <div class="orderBasicInfo">
              <div class="item" v-if="item.orderPhone">
                <div class="left">手机号码：</div>
                <div class="right">
                  {{ item.orderPhone
                  }}<span v-if="
                    item.appId == 402 &&
                    item.orderDetail.licensePlateNo.length > 0
                  ">（{{ item.orderDetail.licensePlateNo }}）</span>
                </div>
              </div>
              <div class="item" v-if="
                item.customerPhone && item.customerPhone != item.orderPhone
              ">
                <div class="left">登录手机号码：</div>
                <div class="right">
                  {{ item.customerPhone }}
                </div>
              </div>
              <div class="item" v-if="item.seriesName">
                <div class="left">意向车系：</div>
                <div class="right">
                  {{ item.seriesName }}
                </div>
              </div>
              <div class="item" v-if="item.contentVehicletype">
                <div class="left">内容车型：</div>
                <div class="right">
                  {{ item.contentVehicletype }}
                </div>
              </div>
              <div class="item" v-if="
                item.customerLabels &&
                item.customerLabels.length > 0 &&
                item.brandId != 70
              ">
                <div class="left">客户标签：</div>
                <div class="right">
                  <span class="customerLabel" v-for="(item2) in item.customerLabels"
                    :key="item2.customerLabelId">
                    {{ item2.customerLabelName }}
                  </span>
                </div>
              </div>
              <div class="item" v-if="
                item.customerLabels &&
                item.customerLabels.length > 0 &&
                item.brandId == 70
              ">
                <div class="left">客户标签：</div>
                <div class="right">
                  <span class="customerLabel" v-for="(item2) in item.customerLabels"
                    :key="item2.customerLabelId">
                    {{ item2.customerLabelName }}
                  </span>
                </div>
              </div>
            </div>
            <div class="orderBasicInfo">
              <div class="item" v-if="item.orderID">
                <div class="left">平台编号：</div>
                <div class="right">
                  {{ item.orderID }}
                </div>
              </div>
              <div class="item" v-show="item.appId == '1801' || item.appId == '1501'" v-if="
                item.deliverDealerList && item.deliverDealerList.length > 0
              ">
                <div class="left">购车经销商：</div>
                <div class="right">
                  <div class="omit">
                    <span v-for="(item1, index) in item.deliverDealerList" :key="index">{{ item1 }}</span>
                  </div>
                </div>
              </div>

              <div class="item orderDealer"
                :class="item.dealerList.length > 1 && !item.isShowDealer ? 'showDealer' : ''"
                v-if="item.appId == '1801' && item.dealerList.length > 0">
                <div class="left">下单经销商：</div>
                <div class="right">
                  <div class="dealerItem" v-for="(item1, index) in item.dealerList" :key="index">
                    <div class="dealer-title">
                      <p style="line-height: 16px" :class="item1.dealerName.length > 18 ? 'morewords' : ''">{{
                        item1.dealerName }}<img v-show="item1.businessLicenseName" src="./img/详情@3x.png" alt=""
                          @click="showDealerDetail(item, item1)" /></p>
                      <div class="dealer-content" :class="item1.dealerName.length > 18 ? 'moreTop' : ''"
                        v-show="item1.dealerName && item1.isShowDetail">
                        <div class="title">{{ item1.dealerName }}</div>
                        <div class="item">
                          <div class="point"></div>
                          <div class="content">
                            <div class="businessName">营业执照名称</div>
                            <div class="address">
                              {{ item1.businessLicenseName }}
                            </div>
                          </div>
                        </div>
                        <div class="item">
                          <div class="point"></div>
                          <div class="content">
                            <div class="businessName">门店地址</div>
                            <div class="address">
                              {{ item1.dealerAddress }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <p style="color: #167dfc" v-show="item1.labelIds">
                      {{
                        item1.labelIds
                          ? item1.labelIds.split(";").join(" | ")
                          : ""
                      }}
                    </p>
                    <p v-show="item1.orderNodeId" style="color: #293e4b">
                      <span style="display: inline-block; min-width: 100px">{{
                        item1.orderNodeId
                      }}</span><span>{{ item1.updateTime }}</span>
                    </p>
                  </div>
                </div>
                <div class="unfold" v-show="item.dealerList.length > 1 && !item.isShowDealer"
                  @click="showDealer(item, item.orderID)">
                  展开<img src="./img/下箭头蓝色.png" alt="" />
                </div>
                <div class="fold" v-show="item.dealerList.length > 1 && item.isShowDealer"
                  @click="showDealer(item, item.orderID)">
                  收起<img src="./img/上箭头蓝色.png" alt="" />
                </div>
              </div>
              <div class="item" v-if="item.activityTitle">
                <div class="left">参与活动：</div>
                <div class="right">
                  {{ item.activityTitle }}
                </div>
              </div>
              <div class="item" v-if="item.businessType">
                <div class="left">业务类型：</div>
                <div class="right">
                  {{ item.businessType == '1' ? '到店' : '购车' }}
                </div>
              </div>
              <div class="item" v-if="item.contentType">
                <div class="left">内容类型：</div>
                <div class="right">
                  {{ item.contentType }}
                </div>
              </div>
              <div class="item" v-if="item.customerUid && item.appId == '1804'">
                <div class="left">用户Uid：</div>
                <div class="right">
                  {{ item.customerUid }}
                </div>
              </div>
              <div class="item" v-if="item.cityName">
                <div class="left">下单城市：</div>
                <div class="right">{{ item.cityName }}</div>
              </div>
              <div class="item" v-if="item.orderTime">
                <div class="left">下单时间：</div>
                <div class="right">
                  {{ item.orderTime | datetimeFormat("yyyy年MM月dd日") }}
                </div>
              </div>
              <div class="item" v-if="item.effectiveTimeList[item.effectiveTimeList.length - 1]">
                <div class="left">权益有效期：</div>
                <div class="right">
                  {{
                    item.effectiveTimeList[item.effectiveTimeList.length - 1]
                  }}
                </div>
              </div>
              <div class="item" v-if="item.netsCustId">
                <div class="left">ITS客户号：</div>
                <div class="right">
                  {{ item.netsCustId }}
                </div>
              </div>
            </div>
            <div class="orderBasicInfo blueBg">
              <div class="item" v-if="item.predictCommission > 0">
                <div class="left">预计奖励：</div>
                <div class="right">
                  {{ item.predictCommission.toFixed(2) }}元
                </div>
              </div>
              <div v-if="item.delayCommission == 0">
                <div class="item" v-if="item.commission && item.commission > 0">
                  <div class="left">应发奖励：</div>
                  <div class="right">
                    <div class="dif" @click="showCommission(item, item.orderID)">
                      <div class="commissionClass">{{ item.commission }}元</div>
                      <img src="./img/下箭头蓝色.png" v-show="!item.isShowCommission" alt="" />
                      <img src="./img/上箭头蓝色.png" v-show="item.isShowCommission" alt="" />
                    </div>
                  </div>
                  <!-- 应发奖励 -->
                  <div class="order-steps min-width" v-show="item.isShowCommission">
                    <div class="order-steps-header">
                      <div class="left">
                        <img src="../../static/img/orderState.png" alt="" />
                        <div class="text">订单状态</div>
                      </div>
                      <div class="right">
                        <img src="../../static/img/佣金.png" alt="" />
                        <div class="text">应发奖励</div>
                      </div>
                    </div>
                    <div class="cut-line"></div>
                    <div class="order-steps-body" v-for="(item2, index) in item.orderStepList"
                      :class="{ bold: index === item.orderStepList.length - 1 }" :key="index">
                      <div class="step-item" v-if="item2.amount">
                        <div class="left">
                          <img src="../../static/img/stateIcon.png" alt="" />
                          <span>{{ item2.nodeName }}</span>
                        </div>
                        <div class="right">{{ item2.amount }}</div>
                      </div>
                      <div class="line" v-show="index < item.orderStepList.length - 1 && item2.amount
                        "></div>
                    </div>
                  </div>
                </div>
                <div class="item" v-if="item.commission && item.commission > 0">
                  <div class="left">实发奖励：</div>
                  <div class="right">
                    <div class="dif" @click="showReward(item, item.orderID)">
                      <div class="commissionClass">
                        {{ item.reward ? item.reward : 0 }}元
                      </div>
                      <img src="./img/下箭头蓝色.png" v-show="!item.isShowReward" alt="" />
                      <img src="./img/上箭头蓝色.png" v-show="item.isShowReward" alt="" />
                    </div>
                    <div class="reason">
                      <img src="../../static/img/mark.png" v-show="item.promptMsg"
                        @click.stop="showPopover(item.orderID)" />
                      <div class="dlrBenefit-intro-rule-pop02" v-show="item.isShowPopover">
                        <div class="dlrBenefit-intro-rule-pop-bg">
                          <span class="h5"> {{ item.promptMsg }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- 实发奖励 -->
                  <div class="order-steps min-width" v-show="item.isShowReward">
                    <div class="order-steps-header">
                      <div class="left">
                        <img src="../../static/img/orderState.png" alt="" />
                        <div class="text">订单状态</div>
                      </div>
                      <div class="right">
                        <img src="../../static/img/佣金.png" alt="" />
                        <div class="text">实发奖励</div>
                      </div>
                    </div>
                    <div class="cut-line"></div>
                    <div class="order-steps-body" v-for="(item2, index) in item.orderStepList"
                      :class="{ bold: index === item.orderStepList.length - 1 }" :key="index">
                      <div class="step-item" v-if="item2.amount">
                        <div class="left">
                          <img src="../../static/img/stateIcon.png" alt="" />
                          <span>{{ item2.nodeName }}</span>
                        </div>
                        <div class="right">
                          {{ item2.actualAmount ? item2.actualAmount : "待结算" }}
                        </div>
                      </div>
                      <div class="line" v-show="index < item.orderStepList.length - 1 && item2.amount
                        "></div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <!-- 首次应发奖励 -->
                <div class="item" v-if="item.commission && item.commission > 0">
                  <div class="left">首次应发奖励：</div>
                  <div class="right">
                    <div class="dif" @click="showCommission(item, item.orderID)">
                      <div class="commissionClass">{{ item.commission }}元</div>
                      <img src="./img/下箭头蓝色.png" v-show="!item.isShowCommission" alt="" />
                      <img src="./img/上箭头蓝色.png" v-show="item.isShowCommission" alt="" />
                    </div>
                  </div>
                  <div class="order-steps min-width" v-show="item.isShowCommission">
                    <div class="order-steps-header">
                      <div class="left">
                        <img src="../../static/img/orderState.png" alt="" />
                        <div class="text">订单状态</div>
                      </div>
                      <div class="right">
                        <img src="../../static/img/佣金.png" alt="" />
                        <div class="text">应发奖励</div>
                      </div>
                    </div>
                    <div class="cut-line"></div>
                    <div class="order-steps-body" v-for="(item2, index) in item.orderStepList"
                      :class="{ bold: index === item.orderStepList.length - 1 }" :key="index">
                      <div class="step-item" v-if="item2.amount">
                        <div class="left">
                          <img src="../../static/img/stateIcon.png" alt="" />
                          <span>{{ item2.nodeName }}</span>
                        </div>
                        <div class="right">{{ item2.amount }}</div>
                      </div>
                      <div class="line" v-show="index < item.orderStepList.length - 1 && item2.amount
                        "></div>
                    </div>
                  </div>
                </div>
                <!-- 首次实发奖励 -->
                <div class="item" v-if="item.commission && item.commission > 0">
                  <div class="left">首次实发奖励：</div>
                  <div class="right">
                    <div class="dif" @click="showReward(item, item.orderID)">
                      <div class="commissionClass">
                        {{ item.reward ? item.reward : 0 }}元
                      </div>
                      <img src="./img/下箭头蓝色.png" v-show="!item.isShowReward" alt="" />
                      <img src="./img/上箭头蓝色.png" v-show="item.isShowReward" alt="" />
                    </div>
                    <div class="reason">
                      <img src="../../static/img/mark.png" v-show="item.promptMsg"
                        @click.stop="showPopover(item.orderID)" />
                      <div class="dlrBenefit-intro-rule-pop02" v-show="item.isShowPopover">
                        <div class="dlrBenefit-intro-rule-pop-bg">
                          <span class="h5"> {{ item.promptMsg }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="order-steps min-width" v-show="item.isShowReward">
                    <div class="order-steps-header">
                      <div class="left">
                        <img src="../../static/img/orderState.png" alt="" />
                        <div class="text">订单状态</div>
                      </div>
                      <div class="right">
                        <img src="../../static/img/佣金.png" alt="" />
                        <div class="text">实发奖励</div>
                      </div>
                    </div>
                    <div class="cut-line"></div>
                    <div class="order-steps-body" v-for="(item2, index) in item.orderStepList"
                      :class="{ bold: index === item.orderStepList.length - 1 }" :key="index">
                      <div class="step-item" v-if="item2.actualAmount">
                        <div class="left">
                          <img src="../../static/img/stateIcon.png" alt="" />
                          <span>{{ item2.nodeName }}</span>
                        </div>
                        <div class="right">
                          {{ item2.actualAmount ? item2.actualAmount : "待结算" }}
                        </div>
                      </div>
                      <div class="line" v-show="item.orderStepList[index + 1] && item.orderStepList[index + 1].actualAmount
                        "></div>
                    </div>
                  </div>
                </div>
                <!-- 延迟应发奖励 -->
                <div class="item" v-if="item.delayCommission && item.delayCommission > 0">
                  <div class="left">延迟应发奖励：</div>
                  <div class="right">
                    <div class="dif" @click="showDelayCommission(item, item.orderID)">
                      <div class="commissionClass">{{ item.delayCommission }}元</div>
                      <img src="./img/下箭头蓝色.png" v-show="!item.isShowDelayCommission" alt="" />
                      <img src="./img/上箭头蓝色.png" v-show="item.isShowDelayCommission" alt="" />
                    </div>
                  </div>

                  <div class="order-steps" v-show="item.isShowDelayCommission">
                    <div class="order-steps-header">
                      <div class="left">
                        <img src="../../static/img/orderState.png" alt="" />
                        <div class="text">订单状态</div>
                      </div>
                      <div class="right">
                        <img src="../../static/img/佣金.png" alt="" />
                        <div class="text">延迟应发奖励</div>
                      </div>
                      <div class="right">
                        <img src="../../static/img/佣金.png" alt="" />
                        <div class="text">延迟结算日期</div>
                      </div>
                    </div>
                    <div class="cut-line"></div>
                    <div class="order-steps-body" v-for="(item2, index) in item.orderStepList"
                      :class="{ bold: index === item.orderStepList.length - 1 }" :key="index">
                      <div class="step-item" v-if="item2.amount">
                        <div class="left">
                          <img src="../../static/img/stateIcon.png" alt="" />
                          <span>{{ item2.nodeName }}</span>
                        </div>
                        <div class="left">
                          <span>{{ item2.delayAmount }}</span>
                        </div>
                        <div class="right">{{ item2.delayTime ? item2.delayTime : "待结算" }}</div>
                      </div>
                      <div class="line" v-show="index < item.orderStepList.length - 1 && item2.amount
                        "></div>
                    </div>
                  </div>
                </div>
                <!-- 延迟实发奖励 -->
                <div class="item" v-if="item.delayReward && item.delayReward > 0">
                  <div class="left">延迟实发奖励：</div>
                  <div class="right">
                    <div class="dif" @click="showDelayReward(item, item.orderID)">
                      <div class="commissionClass">
                        {{ item.delayReward }}元
                      </div>
                      <img src="./img/下箭头蓝色.png" v-show="!item.isShowDelayReward" alt="" />
                      <img src="./img/上箭头蓝色.png" v-show="item.isShowDelayReward" alt="" />
                    </div>
                  </div>

                  <div class="order-steps" v-show="item.isShowDelayReward">
                    <div class="order-steps-header">
                      <div class="left">
                        <img src="../../static/img/orderState.png" alt="" />
                        <div class="text">订单状态</div>
                      </div>
                      <div class="right">
                        <img src="../../static/img/佣金.png" alt="" />
                        <div class="text">延迟实发奖励</div>
                      </div>
                      <div class="right">
                        <img src="../../static/img/佣金.png" alt="" />
                        <div class="text">延迟结算日期</div>
                      </div>
                    </div>
                    <div class="cut-line"></div>
                    <div class="order-steps-body" v-for="(item2, index) in item.orderStepList"
                      :class="{ bold: index === item.orderStepList.length - 1 }" :key="index">
                      <div class="step-item" v-if="item2.delayActualAmount">
                        <div class="left">
                          <img src="../../static/img/stateIcon.png" alt="" />
                          <span>{{ item2.nodeName }}</span>
                        </div>
                        <div class="left">
                          <span>{{ item2.delayActualAmount ? item2.delayActualAmount : "待结算" }}</span>
                        </div>
                        <div class="right">
                          {{ item2.delayTime }}
                        </div>
                      </div>
                      <div class="line"  v-show="item.orderStepList[index + 1] && item.orderStepList[index + 1].delayActualAmount"></div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div class="orderBasicInfo">
              <div class="item" v-if="item.orderState">
                <div class="left">订单状态：</div>
                <div class="right">
                  <div class="commissionClass" @click="showOrderStep(item, item.orderID)">
                    <div v-if="item.appId == '1501'">
                      {{
                        item.orderState == "发票审批通过有效"
                          ? "审批通过有效"
                          : item.orderState == "订单通过有效"
                            ? ""
                            : item.orderState
                      }}
                    </div>
                    <div v-else-if="item.appId == '1801' && item.businessType == 1">
                      {{
                        item.orderState == "成交有效"
                          ? "审核通过有效"
                          : item.orderState
                      }}
                    </div>
                    <div v-else>
                      {{
                        item.orderState == "发票审批通过有效"
                          ? "审批通过有效"
                          : item.orderState
                      }}
                    </div>
                    <img src="./img/下箭头蓝色.png" alt="" v-show="!item.isShowOrderState" />
                    <img src="./img/上箭头蓝色.png" alt="" v-show="item.isShowOrderState" />
                    <div class="reason" v-if="
                      item.reasonList[item.reasonList.length - 1] &&
                      (item.orderState === '审核驳回有效' ||
                        item.orderState === '审核失败有效' ||
                        item.orderState === '内容未通过有效' ||
                        item.orderState === '审批未通过有效')
                    ">
                      <img src="../../static/img/mark.png" alt="" @click.stop="showBubble(item.orderID)" />
                      <div class="dlrBenefit-intro-rule-pop02" v-show="bubbleShow[item.orderID]">
                        <div class="dlrBenefit-intro-rule-pop-bg">
                          <span class="h5">
                            {{
                              item.reasonList[item.reasonList.length - 1]
                            }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="order-steps" v-show="item.isShowOrderState">
                  <div class="order-steps-header">
                    <div class="left">
                      <img src="../../static/img/orderState.png" alt="" />
                      <div class="text">订单状态</div>
                    </div>
                    <div class="right">
                      <img src="../../static/img/undateTime.png" alt="" />
                      <div class="text">更新时间</div>
                    </div>
                  </div>
                  <div class="cut-line"></div>
                  <div class="order-steps-body">
                    <div class="step-item" v-for="(item2, index) in item.orderStepList"
                      :class="{ bold: index === item.orderStepList.length - 1 }" :key="index">
                      <div class="left">
                        <img src="../../static/img/stateIcon.png" alt="" />
                        <span v-if="item2.nodeId == '700' || item2.nodeId == '800'">
                          审批通过
                        </span>
                        <span v-else class="right">{{ item2.nodeName }}</span>
                      </div>
                      <div class="right">
                        {{ item2.createTime | formatDate }}
                      </div>
                    </div>
                    <div class="line line1" v-show="item.orderStepList && item.orderStepList.length > 1
                      "></div>
                    <div class="line line2" v-show="item.orderStepList && item.orderStepList.length > 2
                      "></div>
                    <div class="line line3" v-show="item.orderStepList && item.orderStepList.length > 3
                      "></div>
                    <div class="line line4" v-show="item.orderStepList && item.orderStepList.length > 4
                      "></div>
                    <div class="line line5" v-show="item.orderStepList && item.orderStepList.length > 5
                      "></div>
                    <div class="line line6" v-show="item.orderStepList && item.orderStepList.length > 6
                      "></div>
                    <div class="line line7" v-show="item.orderStepList && item.orderStepList.length > 7
                      "></div>
                    <div class="line line8" v-show="item.orderStepList && item.orderStepList.length > 8
                      "></div>
                    <div class="line line9" v-show="item.orderStepList && item.orderStepList.length > 9
                      "></div>
                    <div class="line line10" v-show="item.orderStepList && item.orderStepList.length > 10
                      "></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-pull-refresh>
    <van-empty v-show="orders.length == 0" description="未找到订单，请更换查询条件" />
    <pull-load target-element="order-list" v-bind:bottom-method="loadMoreOrder" v-bind:state="loadMoreState"
      v-show="orders.length > 10"></pull-load>
    <div class="msk" v-show="isShowMask" v-on:click="isShowMask = false"></div>
    <social-dialog title="正在加载" category="tips" v-bind:show="dialogShow"></social-dialog>
    <!--我的订单-->
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import SocialHeader from "../../components/social-header.vue";
import SocialDialog from "../../components/social-dialog.vue";
import PullLoad from "../../components/pull-load.vue";
import orderApi from "../../api/order";
import Dialog from "../../plugins/dialog.js";
import moment from "moment";
import Vue from "vue";
import {
  isWeiXin,
  isDingDing,
  changeDocumentTitle,
} from "../../service/environment";

export default {
  components: {
    SocialHeader,
    SocialDialog,
    PullLoad,
  },
  name: "AccountOrder",
  data: function () {
    return {
      minDate: new Date(), //日期可选最小值
      maxDate: new Date(), //日期可选最大值
      // 下单时间筛选项枚举
      OrderTime_ENUM: [
        {
          value: "全部",
          key: "0",
        },
        {
          value: "30天",
          key: "1",
        },
        {
          value: "今年",
          key: "2",
        },
        {
          value: "选择时间",
          key: "3",
        },
      ],
      // 订单状态枚举
      OrderState_ENUM: [
        {
          value: "买车活动",
          key: "1",
          child1: [
            {
              value: "留资",
              key: 100,
              selected: false,
            },
            {
              value: "审批中",
              key: 600,
              selected: false,
            },
            {
              value: "审批通过",
              key: "800",
              selected: false,
            },
            {
              value: "审批未通过",
              key: "910,920,930",
              selected: false,
            },
            {
              value: "品牌首触",
              key: "160",
              selected: false,
            },
            {
              value: "订单完成",
              key: "300",
              selected: false,
            },
            {
              value: "已支付",
              key: "480",
              selected: false,
            },
          ],
          child2: [
            {
              value: "线索",
              key: 100,
              selected: false,
            },
            {
              value: "首次上传凭证",
              key: 360,
              selected: false,
            },
            {
              value: "成交",
              key: 300,
              selected: false,
            },
            {
              value: "厂商下大定",
              key: 365,
              selected: false,
            },
            {
              value: "审核驳回",
              key: 900,
              selected: false,
            },
            {
              value: "超时取消",
              key: 910,
              selected: false,
            },
            {
              value: "手动取消",
              key: 920,
              selected: false,
            },
          ],
        },
        {
          value: "卖车活动",
          key: "2",
          child1: [
            {
              value: "线索分发",
              key: 120,
              selected: false,
            },
            {
              value: "线索作废",
              key: 130,
              selected: false,
            },
            {
              value: "线索确认",
              key: 140,
              selected: false,
            },
          ],
          child2: [],
        },
        {
          value: "内容活动",
          key: "4",
          child1: [
            {
              value: "待发布",
              key: 10,
              selected: false,
            },
            {
              value: "审核中",
              key: 20,
              selected: false,
            },
            {
              value: "内容通过",
              key: 30,
              selected: false,
            },
            {
              value: "内容未通过",
              key: 40,
              selected: false,
            },
            {
              value: "审核通过",
              key: 750,
              selected: false,
            },
            {
              value: "审核失败",
              key: 930,
              selected: false,
            },
          ],
          child2: [],
        },
        {
          value: "客户标签",
          key: "3",
          child1: [
            {
              value: "品牌新客",
              key: 1,
              selected: false,
              customerLabel: true,
            },
            {
              value: "品牌老客",
              key: 3,
              selected: false,
              customerLabel: true,
            },
            {
              value: "平安老客",
              key: 4,
              selected: false,
              customerLabel: true,
            },
            {
              value: "品牌首触",
              key: 5,
              selected: false,
              customerLabel: true,
            },
          ],
          child2: [],
        },
      ],
      dataType: [
        {
          value: "数据类型",
          key: "4",
          child1: [
            {
              value: "线索",
              key: 1,
              selected: false,
            },
            {
              value: "订单",
              key: 2,
              selected: false,
            },
            {
              value: "",
              key: 3,
              selected: false,
            },
          ],
        },
      ],
      businessType: [
        {
          value: "业务类型",
          key: "6",
          child1: [
            {
              value: "到店",
              key: 1,
              selected: false,
            },
            {
              value: "购车",
              key: 2,
              selected: false,
            },
            {
              value: "",
              key: 3,
              selected: false,
            },
          ],
        },
      ],
      // 订单类型筛选项枚举
      OrderType_ENUM: [
        {
          value: "订单类型",
          key: "5",
          child1: [
            {
              value: "买车活动",
              key: "1501,1801",
              selected: false,
            },
            {
              value: "卖车活动",
              key: "1001",
              selected: false,
            },
            {
              value: "内容发布",
              key: "1804",
              selected: false,
            },
          ],
        },
      ],
      isShowTimeFilter: false, // 是否显示下单时间筛选项
      isShowStateFilter: false, // 是否显示订单状态筛选项
      isShowSearchFilter: false, // 是否显示订单状态筛选项
      isShowSelectTime: false, // 是否显示选择日期区间组件
      selectTimeItem: "0", // 下单时间选中的筛选项
      selectTimeData: [], //  下单时间选择的时间
      selectOrderNodeData: [], // 选择的订单节点
      selectCustomerLabelData: [], // 选择的客户标签
      searchOrderVal: "", // 查询订单id
      isShowSearchCancel: false, // 是否显示搜索取消按钮
      dialogShow: false,
      loadMoreState: 0,
      isPullRefresh: false,
      bubbleShow: {},
    };
  },
  created: function () {
    this.dialogShow = true;
    changeDocumentTitle("我的订单");
    var current = this;
    current.dateHandle();
    // this.$store.dispatch("getOrders").then(function (res) {
    //   
    // });
    this.selectTime2SearchOrder('2')
    current.dialogShow = false;
  },
  computed: {
    ...mapGetters({
      orders: "orders",
    }),
    isShowMask: {
      get() {
        return (
          this.isShowTimeFilter ||
          this.isShowStateFilter ||
          this.isShowSearchFilter
        );
      },
      set() {
        this.isShowTimeFilter =
          this.isShowStateFilter =
          this.isShowSearchFilter =
          false;
      },
    },
    currentEnv() {
      if (isWeiXin()) {
        return false;
      } else if (isDingDing()) {
        return false;
      } else if (window.entrance.name === 'mainapp') {
        return false;
      } else if (window.entrance.name === 'WxMini') {
        return false;
      } else {
        return true;
      }
    },
    selectNodeData() {
      let selectDataType = this.dataType[0].child1.filter(
        (item) => item.selected
      );
      let businesslineIds = this.OrderType_ENUM[0].child1.filter(
        (item) => item.selected
      );
      let selectbusinessType = this.businessType[0].child1.filter(
        (item) => item.selected
      );
      return this.selectOrderNodeData.concat(
        this.selectCustomerLabelData,
        selectDataType,
        selectbusinessType,
        businesslineIds
      );
    },
  },
  methods: {
    showBubble(orderID) {
      if (!this.bubbleShow.hasOwnProperty(orderID)) {
        Vue.set(this.bubbleShow, orderID, true);
      } else {
        this.bubbleShow[orderID] = !this.bubbleShow[orderID];
      }
    },
    copy: function (texts) {
      var text = texts;
      var input = document.createElement("input");
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      Dialog.toast({ title: "已复制" });
    },
    // 自定义最小最大日历区间
    dateHandle() {
      // 使用moment.js来处理日期，提高代码的可读性和健壮性
      const now = moment();
      this.minDate = now.clone().subtract(5, "years").toDate();
      this.maxDate = now.toDate();
    },
    // 重置筛选项
    toggleFilter(filter, flag) {
      [this.isShowTimeFilter, this.isShowStateFilter, this.isShowSearchFilter] =
        [false, false, false];
      this[filter] = !flag;
    },
    // 显示筛选项
    showFilter(type) {
      switch (type) {
        case "time":
          this.toggleFilter("isShowTimeFilter", this.isShowTimeFilter);
          break;
        case "state":
          this.toggleFilter("isShowStateFilter", this.isShowStateFilter);
          break;
        case "search":
          this.toggleFilter("isShowSearchFilter", this.isShowSearchFilter);
          this.$nextTick(() => {
            this.$refs.search.querySelector("input").focus();
          });
          break;
      }
    },
    // 筛选查询订单
    selectTime2SearchOrder(key) {
      if (this.selectTimeItem !== key && key !== "3") {
        this.dialogShow = true;
        this.selectTimeItem = key;
        let searchTime = {
          beginTime: "",
          endTime: "",
        };
        const now = moment();
        switch (key) {
          case "0":
            this.selectTimeData = [];
            searchTime.beginTime = "";
            searchTime.endTime = "";
            break;
          case "1":
            this.selectTimeData[0] = searchTime.beginTime = now
              .clone()
              .subtract(30, "days")
              .format("YYYY-MM-DD");
            this.selectTimeData[1] = searchTime.endTime =
              now.format("YYYY-MM-DD");
            break;
          case "2":
            this.selectTimeData[0] =
              searchTime.beginTime = `${now.year()}-01-01`;
            this.selectTimeData[1] = searchTime.endTime =
              now.format("YYYY-MM-DD");
            break;
        }
        this.$refs.calendar && this.$refs.calendar.reset();
        this.$store
          .dispatch("setSearchTime", searchTime)
          .then(() => {
            this.dialogShow = false;
          })
          .catch((error) => {
            console.error("Error in setSearchTime:", error);
          });
      } else {
        this.selectTimeItem = "";
      }
      if (key === "3") {
        this.selectTimeItem = key;
        this.isShowSelectTime = true;
      }
      this.isShowTimeFilter = false;
    },
    openCalendar() {
      this.$nextTick(() => {
        const calendarDom = document.querySelector(".van-calendar__body");
        if (calendarDom) {
          let back = calendarDom.scrollTop;
          setTimeout(() => {
            back = calendarDom.scrollTop;
            calendarDom.scrollTop = back - 2;
          }, 10);
          setTimeout(() => {
            calendarDom.scrollTop = back;
          }, 100);
        }
      });
    },
    // 格式化时间
    formatDate(date) {
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      if (month < 10) {
        month = "0" + month;
      }
      if (day < 10) {
        day = "0" + day;
      }
      return `${year}-${month}-${day}`;
    },
    // 确认日期区间
    async confirmTime(date) {
      this.dialogShow = true;
      const [start, end] = date;
      this.selectTimeData = [this.formatDate(start), this.formatDate(end)];
      const searchTime = {
        beginTime: this.formatDate(start),
        endTime: this.formatDate(end),
      };
      try {
        await this.$store.dispatch("setSearchTime", searchTime);
      } catch (error) {
        console.error("Failed to set search time:", error);
      } finally {
        this.dialogShow = false;
      }
      this.isShowSelectTime = false;
      this.isShowTimeFilter = false;
    },
    // 选择订单节点
    selectOrderNode(item) {
      if (item.key != "") {
        let index = this.selectOrderNodeData.indexOf(item);
        let idx = this.selectCustomerLabelData.indexOf(item);
        if (item.customerLabel) {
          if (idx !== -1) {
            this.selectCustomerLabelData.splice(idx, 1);
          } else {
            this.selectCustomerLabelData.push(item);
          }
        } else {
          if (index !== -1) {
            this.selectOrderNodeData.splice(index, 1);
          } else {
            this.selectOrderNodeData.push(item);
          }
        }

        item.selected = !item.selected;
      } else {
        this.selectOrderNodeData = [];
        this.selectCustomerLabelData = [];
        this.setOrderStateFalse();
      }
    },
    // 选择数据类型
    selectDataType(item) {
      this.dataType.forEach((item1) => {
        item1.child1.forEach((item2) => {
          if (item2.key !== item.key) {
            item2.selected = false;
          } else {
            item2.selected = !item2.selected;
          }
        });
      });
    },
    // 选择业务类型 
    selectBusinessType(item) {
      this.businessType.forEach((item1) => {
        item1.child1.forEach((item2) => {
          if (item2.key !== item.key) {
            item2.selected = false;
          } else {
            item2.selected = !item2.selected;
          }
        });
      });
    },
    // 选择订单类型
    selectOrderType(item) {
      this.OrderType_ENUM.forEach((item1) => {
        item1.child1.forEach((item2) => {
          if (item2.key !== item.key) {
            item2.selected = false;
          } else {
            item2.selected = !item2.selected;
          }
        });
      });
    },
    // 清空订单节点/查询订单
    editOrderState(type) {
      const operations = {
        clear: () => {
          this.setOrderStateFalse();
          this.selectOrderNodeData = [];
          this.selectCustomerLabelData = [];
          return { orderNodeIds: "", customerLabelIds: "" };
        },
        confim: () => {
          let data = this.selectOrderNodeData.map((item) => item.key);
          let dataType = this.dataType[0].child1.find((item) => item.selected)
            ? this.dataType[0].child1.find((item) => item.selected).key
            : "";
          let nodeStr = data.join(",");
          let customerStr = this.selectCustomerLabelData
            .map((item) => item.key)
            .join(",");
          let businesslineIds = this.OrderType_ENUM[0].child1.find(
            (item) => item.selected
          )
            ? this.OrderType_ENUM[0].child1.find((item) => item.selected).key
            : "";
          let businessTypeData = this.businessType[0].child1.find(
            (item) => item.selected
          )
            ? this.businessType[0].child1.find((item) => item.selected).key
            : "";
          return {
            orderNodeIds: nodeStr,
            customerLabelIds: customerStr,
            dataType: dataType,
            businessType: businessTypeData,
            businesslineIds: businesslineIds,
          };
        },
      };
      if (operations.hasOwnProperty(type)) {
        this.dialogShow = true;
        let params = operations[type]();
        this.$store
          .dispatch("setSearchOrderNode", params)
          .then((res) => {
            this.dialogShow = false;
          })
          .catch((error) => {
            console.error("An error in setSearchOrderNode:", error);
            this.dialogShow = false;
          });
        this.isShowStateFilter = false;
      }
    },
    // 设置订单节点为非选中状态
    setOrderStateFalse() {
      this.OrderState_ENUM.forEach((item) => {
        item.child1.forEach((item1) => {
          if (item1.key != "") {
            item1.selected = false;
          } else {
            item1.selected = true;
          }
        });
        item.child2.forEach((item2) => (item2.selected = false));
      });
      this.dataType.forEach((item) => {
        item.child1.forEach((item1) => {
          if (item1.key != "") {
            item1.selected = false;
          } else {
            item1.selected = true;
          }
        });
      });
      this.businessType.forEach((item) => {
        item.child1.forEach((item1) => {
          if (item1.key != "") {
            item1.selected = false;
          } else {
            item1.selected = true;
          }
        });
      });
      this.OrderType_ENUM.forEach((item) => {
        item.child1.forEach((item1) => {
          if (item1.key != "") {
            item1.selected = false;
          } else {
            item1.selected = true;
          }
        });
      });
    },
    // 重置搜索订单id
    reset() {
      this.searchOrderVal = "";
      this.$store
        .dispatch("setSearchOrder", {
          matchingFields: this.searchOrderVal,
          checkType: ''
        })
        .then(() => {
          this.dialogShow = false;
        })
        .catch((error) => {
          console.error("An error occurred:", error);
          this.dialogShow = false; // 确保对话框关闭
        })
        .finally(() => {
          this.searchOrderVal = "";
          this.isShowSearchFilter = false;
          this.isShowSearchCancel = false;
          this.loadMoreState = 0;
        });
    },
    // 根据订单id或手机号搜索
    onSearch() {
      this.dialogShow = true;
      this.$store
        .dispatch("setSearchOrder", {
          matchingFields: this.searchOrderVal,
          checkType: ""
        })
        .then(() => {
          this.dialogShow = false;
        })
        .catch((error) => {
          console.error("An error occurred:", error);
          this.dialogShow = false; // 确保对话框关闭
        })
        .finally(() => {
          this.isShowMask = false;
          this.isShowSearchCancel = true;
        });
    },
    // 滚动加载更多
    loadMoreOrder: function () {
      if (this.loadMoreState !== 0) {
        return false;
      }
      this.loadMoreState = 1;
      var current = this;
      this.$store.dispatch("loadMoreOrders").then(function () {
        current.loadMoreState = 0;
        if (current.$store.getters.isOrderPageEnd) {
          current.loadMoreState = 2;
        }
        current.dialogShow = false;
      });
    },
    // 获取订单状态
    getOrderStateList(id, businessType) {
      orderApi.getOrderStateList(id, businessType).then((res) => {
        this.$store.commit("CHANGE_ORDER_STEP_LIST", {
          orderId: id,
          list: res.data.result.orders,
        });
      });
    },
    // 展示订单流程
    //应发奖励
    showCommission(item, id) {
      if (!item.isShowCommission) {
        this.getOrderStateList(id);
        this.$store.commit("CHANGE_ORDER_COMMISSION_STATE", id);
      } else {
        this.$store.commit("CHANGE_ORDER_COMMISSION_STATE", id);
      }
    },
    //延迟应发奖励
    showDelayCommission(item, id) {
      if (!item.isShowDelayCommission) {
        this.getOrderStateList(id);
        this.$store.commit("CHANGE_ORDER_DELAY_COMMISSION_STATE", id);
      } else {
        this.$store.commit("CHANGE_ORDER_DELAY_COMMISSION_STATE", id);
      }
    },
    //实发奖励
    showReward(item, id) {
      if (!item.isShowReward) {
        this.getOrderStateList(id);
        this.$store.commit("CHANGE_ORDER_REWARD_STATE", id);
      } else {
        this.$store.commit("CHANGE_ORDER_REWARD_STATE", id);
      }
    },
    //延迟实发奖励
    showDelayReward(item, id) {
      if (!item.isShowDelayReward) {
        this.getOrderStateList(id);
        this.$store.commit("CHANGE_ORDER_DELAY_REWARD_STATE", id);
      } else {
        this.$store.commit("CHANGE_ORDER_DELAY_REWARD_STATE", id);
      }
    },
    // 展开经销商
    showDealer(item, id) {
      if (!item.isShowDealer) {
        this.$store.commit("CHANGE_ORDER_DEALER_STATE", id);
      } else {
        this.$store.commit("CHANGE_ORDER_DEALER_STATE", id);
      }
    },
    showOrderStep(item, id) {
      if (!item.isShowOrderState) {
        this.getOrderStateList(id, item.businessType);
        this.$store.commit("CHANGE_ORDER_STEP_STATE", id);
      } else {
        this.$store.commit("CHANGE_ORDER_STEP_STATE", id);
      }
    },
    showPopover(id) {
      this.$store.commit("CHANGE_ORDER_POPOVER", id);
    },
    showOrderStep(item, id) {
      if (!item.isShowOrderState) {
        this.getOrderStateList(id);
        this.$store.commit("CHANGE_ORDER_STEP_STATE", id);
      } else {
        this.$store.commit("CHANGE_ORDER_STEP_STATE", id);
      }
    },
    // 展开经销商查看营业执照
    showDealerDetail(item, item1) {
      item.isShowDealer = true;
      item.dealerList.forEach((item2) => {
        if (item2.dealerId != item1.dealerId) {
          item2.isShowDetail = false;
        }
      });
      item1.isShowDetail = !item1.isShowDetail;
    },
    // 下拉刷新
    onRefresh() {
      const current = this;
      current.dialogShow = true;
      this.$store.dispatch("getOrders").then(function (res) {
        current.dialogShow = false;
        current.isPullRefresh = false;
        Dialog.toast({ title: "刷新成功" });
      });
    },
    // 滚动事件
    scrollHandler() {
      var currentScrollPosition = window.scrollY || window.pageYOffset;
      var navBar = document.getElementsByClassName("order-nav-wrap")[0];
      navBar.style.top =
        currentScrollPosition > 51 || !this.currentEnv ? "0" : "2.88rem";
    },
    // 查看首触订单
    async viewRelationOrder(item) {
      this.selectTimeData = [];
      this.$store.commit("SET_SEARCH_TIME", {
        beginTime: "",
        endTime: "",
      });
      this.selectOrderNodeData = [];
      this.selectCustomerLabelData = [];
      this.setOrderStateFalse();
      this.dataType.forEach((item) => {
        item.child1.forEach((item1) => {
          item1.selected = false;
        });
      });
      this.businessType.forEach((item) => {
        item.child1.forEach((item1) => {
          item1.selected = false;
        });
      });
      this.$store.commit("SET_SEARCH_ORDER_NODE", {
        orderNodeIds: "",
        customerLabelIds: "",
        dataType: "",
        businessType: ""
      });
      this.showFilter("search");
      this.dialogShow = true;
      switch (item.dataType) {
        case 1:
          this.searchOrderVal = item.businessLineOrderId;
          this.$store
            .dispatch("setSearchOrder", {
              matchingFields: item.businessLineOrderId,
              checkType: 1
            })
            .then(() => {
              this.dialogShow = false;
            })
            .catch((error) => {
              console.error("An error occurred:", error);
              this.dialogShow = false; // 确保对话框关闭
            })
            .finally(() => {
              this.isShowMask = false;
              this.isShowSearchCancel = true;
            });
          break;
        case 2:
          this.searchOrderVal = item.clueId;
          this.$store
            .dispatch("setSearchOrder", {
              matchingFields: item.clueId,
              checkType: 2
            })
            .then(() => {
              this.dialogShow = false;
            })
            .catch((error) => {
              console.error("An error occurred:", error);
              this.dialogShow = false; // 确保对话框关闭
            })
            .finally(() => {
              this.isShowMask = false;
              this.isShowSearchCancel = true;
            });
          break;
        default:
          this.dialogShow = false;
          this.isShowMask = false;
      }
    },
  },
  watch: {
    selectOrderNodeData(nval, oval) {
      if (oval.length == 0) {
        this.OrderState_ENUM.forEach((item) => {
          item.child1.forEach((item2) => {
            if (item2.key == "") {
              item2.selected = true;
            }
          });
        });
      }
      if (nval.length != 0) {
        this.OrderState_ENUM.forEach((item) => {
          item.child1.forEach((item2) => {
            if (item2.key == "") {
              item2.selected = false;
            }
          });
        });
      }
    },
    selectCustomerLabelData(nval, oval) {
      if (oval.length == 0) {
        this.OrderState_ENUM.forEach((item) => {
          item.child1.forEach((item2) => {
            if (item2.key == "") {
              item2.selected = true;
            }
          });
        });
      }
      if (nval.length != 0) {
        this.OrderState_ENUM.forEach((item) => {
          item.child1.forEach((item2) => {
            if (item2.key == "") {
              item2.selected = false;
            }
          });
        });
      }
    },
  },
  beforeMount() {
    window.addEventListener("scroll", this.scrollHandler)
  },

  beforeDestroy() {
    this.$store.dispatch("setSearchTime", { beginTime: "", endTime: "" });
    this.$store.dispatch("setSearchOrderNode", { orderNodeIds: "" });
    this.$store.dispatch("setSearchOrder", { matchingFields: "", checkType: "" });
    window.removeEventListener("scroll", this.scrollHandler);
  },
};
</script>
<style src="./order.css" scoped></style>



// WEBPACK FOOTER //
// src/pages/account/orders.vue